module.exports = __webpack_public_path__ + "static/scale-model-of-anthony-holmead-archeological-site-in-washington-d.c.-ef0c50555e4d4fbf77d04452fa7fd403.png";